module.exports = __webpack_public_path__ + "img/video.9343a0ff.png";